






























import { Component, Prop, Watch } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import DataSource from 'devextreme/data/data_source';
import DxDateBox from 'devextreme-vue/date-box';
import {
    Table,
    TableOptions,
    getTableCaption,
    columnTemplates,
} from '@/core/components/table';
import { Page } from '@/core/components/controls';
import { FetchServiceContract, CONTRACTS } from '@/core/contracts';
import AuditTable from './AuditTable.vue';
import { encodeParams } from '@/core/helpers';

@Component({
    components: {
        AuditTable,
        TableOptions,
        DxDateBox,
    },
})
export default class AuditPage extends Page {
    public table: Table | null = null;
    public tableKey: string = 'audit-control';
    public startTime: Date | null = null;
    public finishTime: Date | null = null;

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public async mounted() {
        this.table = this.getTable().getDataGridInstance();
        const lastWeek = new Date();
        lastWeek.setDate(lastWeek.getDate() - 7);
        this.startTime = lastWeek;
        this.finishTime = new Date();
    }

    public setTable(table: Table): void {
        this.table = table;
    }

    public getTable(): AuditTable {
        const element = this.$refs['table-control'] as unknown;
        return element as AuditTable;
    }

    public reload() {
        this.getTable().tableInstance.refresh();
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get dataSource(): DataSource {
        return new DataSource({
            load: this.load,
        });
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    @Watch('startTime')
    private onStartTimeChanged() {
        this.reload();
    }

    @Watch('finishTime')
    private onFinishTimeChanged() {
        this.reload();
    }

    private async load() {
        const finishTime = this.finishTime;

        if (finishTime) {
            finishTime.setDate(finishTime.getDate() + 1);
        }

        const params = {
            startTime: this.startTime?.toISOString(),
            finishTime: finishTime?.toISOString(),
        };
        const url = `/audit/actions?${encodeParams(params)}`;
        const data = await this._fetchService!.get<any>(url);
        return { data };
    }
}
